import { render, staticRenderFns } from "./PlanAdhesionPage.vue?vue&type=template&id=01fa7b0e&scoped=true&"
import script from "./PlanAdhesionPage.vue?vue&type=script&lang=js&"
export * from "./PlanAdhesionPage.vue?vue&type=script&lang=js&"
import style0 from "./PlanAdhesionPage.vue?vue&type=style&index=0&id=01fa7b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa7b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VIcon,VProgressLinear})
